import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { MetaDataService } from '../services/meta-data.service';
import { MetadataModel } from '../../../shared/data/models/metadata.model';

@Component({
  selector: 'preview-url',
  templateUrl: './preview-url.component.html',
  styleUrls: ['./preview-url.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviewUrlComponent implements OnInit {
  @Input() url: string;

  urlMetaData: MetadataModel;

  constructor(
    private metaDataService: MetaDataService,
    private refChangeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.url) {
      this.metaDataService.getMetadata(this.url).subscribe(meta => {
        if (meta.data) {
          this.urlMetaData = meta?.data?.createMetadata;
          this.refChangeDetector.detectChanges();
        }
      });
    }
  }
}
